import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import AddGiosg from 'careers/components/add-giosg'
import { Box } from 'components/styled/containers/box'
import { CardGroup } from 'components/styled/card-group'
import { formatDateTimeTimezone } from 'utils/date'
import { Flex } from 'components/styled/containers/flex'
import { H3 } from 'components/styled/typography'
import { imagePath } from 'utils/image'
import { logEvent, EVENT_ACTIONS } from 'actions/audit-trail'
import Logo from 'components/logo'
import { mapLanguageToComponentProps } from 'careers/i18n'
import { MediumHeaderContent } from 'components/page-header/medium-header-content'
import MetaTags from 'components/metatags/metatags'
import { PageContent } from 'components/styled/page/page-content'
import { PageHeader } from 'components/page-header'
import Share from 'components/share'
import ThirdPartyScripts from 'careers/components/third-party-scripts'
import { JobAdCard } from '../../components/styled/job-ad-card'
import { CompanyType } from 'types'
import { I18nComponentType } from 'careers/i18n-types'

interface JobAdListProps {
  company?: CompanyType
  i18n: I18nComponentType
  dispatch: any
}

const mapStateToProps = (state: any) => ({
  company: state.careers.company,
})

export function JobAdList({ company, i18n, dispatch }: JobAdListProps) {
  useEffect(() => {
    if (company) {
      dispatch(
        logEvent({
          ec: company._id,
          ea: EVENT_ACTIONS.jobAdListView,
        })
      )
    }
  }, [])

  const filteredJobAds =
    company && company.jobAds
      ? company.jobAds.filter(({ status }) => status === 'open')
      : []

  const share = company && (
    <Share
      key="share"
      services={['linkedin', 'facebook', 'x-twitter']}
      url={`/careers/${company.language}/${company.slug}/`}
      title={`${company.name} ${i18n.jobAdList.jobs}`}
      locationId="careersJobAdListingPage"
    />
  )

  if (company && company._id) {
    return (
      <>
        <MetaTags
          // @ts-ignore (temporary fix)
          title={company.name}
          description={i18n.jobAdList.title}
          photo={imagePath(company.logo)}
        />
        <PageHeader photo={imagePath(company.photo)} actionsRight={[share]}>
          <MediumHeaderContent title={company.careersSlogan || company.name} />
        </PageHeader>
        <PageContent size="large">
          <Logo logo={imagePath(company.logo)} />
          {filteredJobAds.length > 0 ? (
            <Box mb="s24">
              <H3>{i18n.jobAdList.title}</H3>
              <CardGroup minWidth="s320" gridGap="s40">
                {filteredJobAds.map(ad => (
                  <JobAdCard
                    jobAdEndTime={
                      ad.endTime
                        ? i18n.jobAdCard.openUntil(
                            formatDateTimeTimezone(ad.endTime)
                          )
                        : undefined
                    }
                    jobAd={ad}
                    company={company}
                    key={ad._id}
                  />
                ))}
              </CardGroup>
            </Box>
          ) : (
            <Flex justifyContent="center">
              <H3>{i18n.jobAdList.noJobAds}</H3>
            </Flex>
          )}
        </PageContent>
        <AddGiosg enableGiosg={company.enableGiosg} />
        <ThirdPartyScripts />
      </>
    )
  }

  return null
}

export default connect(mapLanguageToComponentProps(mapStateToProps))(JobAdList)
